<div class="wrapper">
  <div class="cart">
    <div class="cart-header">
        CART
        <button kendoButton class="cartBtn" (click)="showCart($event)">
          <span>
            <kendo-icon size="large" name="x"></kendo-icon>
          </span>
        </button>
    </div>
    <div class="mainCartItemsContainer">
      @for(item of cartItems; track item; let i = $index){
      <div class="cartItem" id="item_{{i}}">
        {{item.itemTitle}}
        @if(item.option != ""){
        <ul>
          <li>{{item.option}}</li>
        </ul>
        }
        <div class="quantity" style="">
          <div class="component-container">
            <kendo-numerictextbox id="numerictextbox_{{i}}"
                                  format="##"
                                  [value]="item.quantity"
                                  [min]="1"
                                  (valueChange)="onChange($event)"></kendo-numerictextbox>
          </div>
          <div class="skeleton-container bottom">
            <div class="k-skeleton skeleton-box-small"></div>
            <div class="k-skeleton skeleton-box-large-double"></div>
          </div>
          <button kendoButton (click)="saveQuantity($event, item.itemId, item.optionId)">
            <span>
              <kendo-icon size="large" name="save"></kendo-icon>
            </span>
          </button>
          <button kendoButton class="removeCartItemBtn" (click)="removeFromCart($event, item.itemId, i, item.optionId)">
            <span>
              <kendo-icon size="large" name="trash"></kendo-icon>
            </span>
          </button>
        </div>
      </div>
      }
      @for(item of miscCartItems; track item; let i = $index){
      <div class="cartItem" id="miscItem_{{i}}">
        {{item.miscellaneousItemTitle}} - {{item.isLegalHold}}
        <div class="quantity" style="">
          <div class="component-container">
            <kendo-numerictextbox #numericTextBoxes id="numerictextbox_{{i}}"
                                  format="##"
                                  [value]="item.quantity"
                                  [min]="1"
                                  (valueChange)="onChange($event)"></kendo-numerictextbox>
          </div>
          <div class="skeleton-container bottom">
            <div class="k-skeleton skeleton-box-small"></div>
            <div class="k-skeleton skeleton-box-large-double"></div>
          </div>
          <button kendoButton (click)="saveItemMiscQuantity($event, item.miscellaneousItemId, i)">
            <span>
              <kendo-icon size="large" name="save"></kendo-icon>
            </span>
          </button>
          <button kendoButton class="removeCartItemBtn" (click)="removeMiscItemsFromCart($event, item.miscellaneousItemId, i)">
            <span>
              <kendo-icon size="large" name="trash"></kendo-icon>
            </span>
          </button>
        </div>
      </div>
      }

      <div class="cartItem" id="testing">
        <div style="">
          <div class="component-container" style="text-align: center">
            <button kendoButton class="checkoutBtn" (click)="redirectToCheckOut($event)">
              CHECKOUT
            </button>
            <p style="text-align: center; margin: 5px 5px 5px 5px; letter-spacing: 0.2em; text-transform: uppercase;">or</p>
            <button kendoButton class="continueShoppingBtn" (click)="redirectToItemSearch($event)">
              CONTINUE SHOPPING
            </button>
          </div>
          <div class="skeleton-container bottom">
            <div class="k-skeleton skeleton-box-small"></div>
            <div class="k-skeleton skeleton-box-large-double"></div>
          </div> 
        </div>
      </div>
    </div>
    <!--<div class="cart-footer">
      <button kendoButton class="checkoutBtn" (click)="redirectToCheckOut($event)">
        CHECKOUT
      </button>
      <p style="text-align: center; margin: 5px 5px 5px 5px">or</p>
      <button kendoButton class="continueShoppingBtn" (click)="redirectToItemSearch($event)">
        CONTINUE SHOPPING
      </button>
    </div>-->
  </div>
</div>

<kendo-stacklayout orientation="vertical" style="width:100%">

  @if (openTimeout) {
  <kendo-dialog title="Attention!" [animation]="true" (close)="closeTimeoutDialog()">
    <p>
      Certain items you've reserved went past the 30 minute time cap: <br>
    </p>

    @for(item of timedOutCartItems; track item) {
    <table id="cartTable">
      <thead>
        <tr>
          <th style="text-align: left; width:250px">Product</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody style="border-top-color: green;">
        <tr>
          <td style="text-align: left; width:250px">{{item.itemTitle}}</td>
          <td> {{item.quantity}}</td>
        </tr>
      </tbody>
    </table>
    }

    @for(item of timedOutCartMiscItems; track item) {
    <table id="cartTable">
      <thead>
        <tr>
          <th style="text-align: left; width:250px">Product</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody style="border-top-color: green;">
        <tr>
          <td style="text-align: left; width:250px">{{item.miscellaneousItemTitle}}</td>
          <td> {{item.quantity}}</td>
        </tr>
      </tbody>
    </table>
    }

    <p>
      The other items in your cart have been removed and returned to available status. <br>
      Please re-add your items and checkout within the 30 minute mark.
    </p>

    <kendo-dialog-actions>
      @if (dialogIcon) {
      <button kendoButton themeColor="tertiary" (click)="acknowledgeTimedOutItems()" [svgIcon]="dialogYes">
        Acknowledge
      </button>
      }
      @else {
      <button kendoButton themeColor="tertiary" (click)="acknowledgeTimedOutItems()">
        Acknowledge
      </button>
      }
    </kendo-dialog-actions>
  </kendo-dialog>
  }
</kendo-stacklayout>
